<template>
  <div class="about-us-container">
    <MyHeader :useAboutUsStyle="true" :bg="bgUrl">
      <template slot="name">
        <span v-if="$isCN()">推动汽车产业<br />数字文明</span>
        <span v-else>Dedicated Enabler<br />to China's Auto Merchants</span>
      </template>
      <template slot="nameSecond">
        <span v-if="$isCN()">以先进运营系统和完善交易服务，<br />让车商经营更方便、交易更高效</span>
        <span v-else
          >Improving Auto Merchants' Operation Efficiency and Profitability through Industry-leading Operating Systems and Integrated High
          Quality Transaction Services</span
        >
      </template>
    </MyHeader>
    <!-- Promote a digital civilization in automobile industry, leveraging data and technology to drive transaction and to enhance efficiency of both business service and market circulation. -->
    <div :id="$i18Id($t('发展历程'))"></div>
    <SectionTitle title="发展历程" titleEN="Company history" class="mt-90 mb-70" />
    <History />
    <div :id="$i18Id($t('投资人背景'))" class="anchor_trans"></div>
    <div class="investor-root">
      <div class="page-content items-center">
        <SectionTitle title="投资人背景" titleEN="Investor List" />
        <span class="investor">{{ !$isMob() ? $t("investor") : $t("investorMob") }}</span>
        <div class="investor-list">
          <www-picture class="investor-item" w="180" h="80" img="//img.souche.com/f2e/724a1a375d31ce5d0e70dc03582dc543.png" />
          <www-picture class="investor-item" w="180" h="80" img="//img.souche.com/f2e/638a7ae6e9cab5212d93944837755b61.png" />
          <www-picture class="investor-item" w="180" h="80" img="//img.souche.com/f2e/0af03693cb5768c6d578b36c6da948dc.png" />
          <www-picture class="investor-item" w="180" h="80" img="//img.souche.com/f2e/747bbf8d66fe4db404bf4adfa07906f2.png" />
        </div>
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyFooter from "../../../../components/MyFooter.vue";
import MyHeader from "../../../../components/MyHeader.vue";
import SectionTitle from "../../../../components/SectionTitle.vue";
import History from "../../../../components/History.vue";

export default {
  data() {
    return {};
  },
  computed: {
    bgUrl() {
      return this.$store.state.isMobileSite
        ? "//img.souche.com/f2e/4c6cf8fa62a6ca3a85485555697c57ce.png"
        : "//img.souche.com/f2e/f0e2dce012870dd622a86fb922ff6d46.png";
    },
  },
  components: {
    MyHeader,
    MyFooter,
    History,
    SectionTitle,
  },
  methods: {},
  mounted() {},
  beforeDestroy() {},
  i18n: {
    messages: {
      zh: {
        title: "关于我们",
        发展历程: "发展历程",
        投资人背景: "投资人背景",
        investor:
          "大搜车已累计获得蚂蚁集团、华平投资（Warburg Pincus）、春华资本（Primavera）、五源资本（5Y Capital）等机构约12亿美元投资。",
        investorMob:
          "大搜车已累计获得蚂蚁集团、\n华平投资（Warburg Pincus）、春华资本（Primavera）、\n五源资本（5Y Capital）等机构约12亿美元投资。",
      },
      en: {
        title: "ABOUT US",
        发展历程: "Company history",
        投资人背景: "Investor List",
        investor:
          "DaSouChe has raised a total of approximately $1.2 billion from first-tier institutions including Ant Group, Warburg Pincus, Primavera, and 5Y Capital.",
        investorMob:
          "DaSouChe has raised a total of approximately $1.2 billion from first-tier institutions including Ant Group, Warburg Pincus, Primavera, and 5Y Capital.",
      },
    },
  },
  head() {
    return {
      title: this.$t("title"),
    };
  },
};
</script>

<style lang="less" scoped>
.investor-root {
  background: linear-gradient(
    247.8deg,
    #ffd9cb 0%,
    rgba(255, 217, 203, 0) 51.04%,
    rgba(255, 217, 203, 0) 99.99%,
    rgba(255, 217, 203, 0) 100%
  );
  padding-top: 46px;
  padding-bottom: 92px;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background-size: cover;
}
.investor {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: #2b2c2e;
  margin-top: 70px;
}

.investor-list {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  .investor-item {
    background: linear-gradient(180deg, #f6f7fb 0%, #ffffff 100%);
    box-shadow: 1px 5px 12px #f4f1f0;
    border-radius: 4px;
    width: 250px;
    height: 112px;
    padding: 22px 52px;
    box-sizing: border-box;
    overflow: hidden;

    &:not(:first-child) {
      margin-left: 28px;
    }
  }
}

@media screen and (max-width: 540px) {
  .investor-root {
    background: unset;
    padding-top: 20px;
    padding-bottom: 30px;
  }

  .investor {
    font-size: 13px;
    line-height: 21px;
    max-width: 100%;
    margin-top: 16px;
    white-space: pre-line;
  }

  .investor-list {
    margin-top: 16px;
    display: grid;
    grid-template-columns: 142px 142px;
    grid-template-rows: 63px;
    row-gap: 12px;
    column-gap: 12px;

    .investor-item {
      background: linear-gradient(180deg, #f6f7fb 0%, #ffffff 100%);
      box-shadow: 1px 2px 6px #f4f1f0;
      border-radius: 2px;
      width: 142px;
      height: 63px;
      padding: 11px 26px;
      margin-left: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/about-us/index.vue